import { render, staticRenderFns } from "./MkObjContent.vue?vue&type=template&id=7a084d2a&"
import script from "./MkObjContent.vue?vue&type=script&lang=js&"
export * from "./MkObjContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports